import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Col,
  KeyValue,
  Row,
} from '@folio/stripes/components';

import { requestPreferencesShape } from '../../../../../shapes';

import styles from './RequestPreferencesView.css';

class RequestPreferencesView extends Component {
  static propTypes = {
    requestPreferences: requestPreferencesShape,
    defaultServicePointName: PropTypes.string,
    defaultDeliveryAddressTypeName: PropTypes.string.isRequired,
    intl: PropTypes.object,
  };

  getHoldShelfStateTranslationKey() {
    return this.props.requestPreferences.holdShelf
      ? 'ui-users.requests.holdShelfYes'
      : 'ui-users.requests.holdShelfNo';
  }

  getDeliveryStateTranslationKey() {
    return this.props.requestPreferences.delivery
      ? 'ui-users.requests.deliveryYes'
      : 'ui-users.requests.deliveryNo';
  }

  render() {
    const {
      requestPreferences,
      defaultServicePointName,
      defaultDeliveryAddressTypeName,
    } = this.props;

    return (
      <>
        <Row>
          <Col xs={4}>
            <span className={styles.heading}>
              <FormattedMessage id="ui-users.requests.preferences" />
            </span>
          </Col>
        </Row>
        <Row className={styles['request-preferences-row']}>
          <Col xs={4} data-test-hold-shelf>
            <FormattedMessage id={this.getHoldShelfStateTranslationKey()} />
          </Col>
          <Col xs={4} data-test-delivery>
            <FormattedMessage id={this.getDeliveryStateTranslationKey()} />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            {requestPreferences.holdShelf && (
              <KeyValue label={<FormattedMessage id="ui-users.requests.defaultPickupServicePoint" />}>
                <span data-test-default-pickup-service-point>
                  {/** kware start edit */}
                  {defaultServicePointName
                    ? this.props.intl.formatMessage({
                      id: `ui-tenant-settings.servicePoints.name.${defaultServicePointName}`,
                      defaultMessage: defaultServicePointName,
                    })
                    : '-'}
                  {/** kware end edit */}
                </span>
              </KeyValue>
            )}
          </Col>
          <Col xs={4}>
            {requestPreferences.delivery && (
              <KeyValue label={<FormattedMessage id="ui-users.requests.fulfillmentPreference" />}>
                <span data-test-fulfillment-preference>
                  {requestPreferences?.fulfillment === 'Hold Shelf' ? (
                    <FormattedMessage id="ui-users.requests.holdShelf" />
                  ) : (
                    <FormattedMessage id="ui-users.requests.delivery" />
                  )}
                </span>
              </KeyValue>
            )}
          </Col>
        </Row>
        <Row>
          <Col xsOffset={4} xs={8}>
            {requestPreferences.delivery && (
              <KeyValue label={<FormattedMessage id="ui-users.requests.defaultDeliveryAddress" />}>
                <span data-test-default-delivery-address>
                  {defaultDeliveryAddressTypeName ? (
                    <FormattedMessage
                      id={`ui-users.addressTypes.addressType.${defaultDeliveryAddressTypeName}`}
                      defaultMessage={defaultDeliveryAddressTypeName}
                    />
                  ) : (
                    '-'
                  )}
                </span>
              </KeyValue>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default injectIntl(RequestPreferencesView);
